<ion-list *ngIf="myUnit">
  <app-status-item *ngFor="let status of statuses" [myUnit]="myUnit" [status]="status" (onClick)="change(status)"></app-status-item>
</ion-list>
